var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 w-100 m-0 p-0",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_c('Alerts',{key:_vm.alerts_refresh,attrs:{"position":"bottom-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }